import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter as Router, Route } from 'react-router-dom';
import SlideRoutes from 'react-slide-routes';
import Home from './components/Home/Home';
import Header from './components/Header/Header';
import Comics from './components/Comics/Comics';
import Experience from './components/Experience/Experience';
import About from './components/About/About';
import reportWebVitals from './reportWebVitals';
import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <>
    <Header />
    <SlideRoutes>
      <Route path="/" element={<Home />} />
      <Route path="/experience" element={<Experience />} />
      <Route path="/about" element={<About />} />
      <Route path="/comics" element={<Comics />} />
    </SlideRoutes>
    </>
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
